import { useState } from 'react'
import { cellText } from './describe'
import { drillDefinition } from './drill'
import type { CatalogSet, Definition, Locale, RunResult } from './types'

export interface Drill {
  /** Rezultatul din care s-a apasat; un rezultat nou inchide panoul. */
  from: string
  title: string
  definition: Definition
}

/** Starea panoului si ce se da lui `ResultView.onDrill`. */
export function useDrill(definition: Definition | null, sets: CatalogSet[], result: RunResult | undefined, from: string, locale: Locale) {
  const [drill, setDrill] = useState<Drill | null>(null)
  const set = definition ? sets.find((s) => s.key === definition.dataset) : undefined
  const open = drill && drill.from === from ? drill : null
  const onDrill =
    definition && set && result
      ? (row: number) => {
          const next = drillDefinition(definition, set, result, row)
          if (!next) return
          const r = result.rows[row]!
          const title = result.columns
            .map((c, i) => (c.role === 'group' ? cellText(r.values[i] ?? null, c, locale) || (locale === 'ro' ? '(gol)' : '(empty)') : null))
            .filter((x) => x !== null)
            .join(' · ')
          setDrill({ from, title, definition: next })
        }
      : undefined
  return { drill: open, onDrill, close: () => setDrill(null) }
}
